import { useCallback } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
export function usePromotionTracking() {
    const accountInfo = getSelectedAccountInfo();
    const documentNumber = accountInfo?.documentNumber || '';
    const companyName = accountInfo?.companyName || '';
    const trackViewPromotion = useCallback((params) => {
        datadogRum.addAction('view_promotion', {
            promotion_name: params.promotion_name,
            company_name: companyName,
            document_number: documentNumber,
        });
    }, [documentNumber, companyName]);
    const trackSelectPromotion = useCallback((params) => {
        datadogRum.addAction('select_promotion', {
            promotion_name: params.promotion_name,
            company_name: companyName,
            document_number: documentNumber,
        });
    }, [documentNumber, companyName]);
    return { trackViewPromotion, trackSelectPromotion };
}
